import React from 'react';
import { I18n } from 'react-redux-i18n';

import { ViewTable } from '../../layouts/viewTable';
import { getOriginLabel, OriginVariant } from '../../../helpers/originHelper';

interface OriginCardProps {
  source?: string | null;
  isShowEmptyFields?: boolean;
  /** Label set to use. Page entity screens pass 'page'; sales/subscriptions use the default. */
  variant?: OriginVariant;
}

/**
 * Reusable "Origin" card for entity view screens (Fundraiser/Team/Collection
 * and Sales). Renders the localized origin label via the shared `common.origin`
 * namespace. Hidden entirely when there is no recognised origin, unless the
 * screen's "show empty fields" toggle is on.
 */
export const OriginCard: React.FC<OriginCardProps> = ({
  source,
  isShowEmptyFields,
  variant = 'default'
}) => {
  const label = getOriginLabel(source, variant);

  if (!label && !isShowEmptyFields) {
    return null;
  }

  return (
    <div className="entity-origin">
      <ViewTable title={I18n.t('common.origin.title')}>
        <span>{label || I18n.t('common.not-available')}</span>
      </ViewTable>
    </div>
  );
};
